import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

export const bureauSchema = new schema.Entity('bureaus', {});

export const bureaus = configureApiEntity('BUREAUS', 'bureaus', bureauSchema);
